var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{staticClass:"map",attrs:{"id":"map"}}),(_vm.showLegend)?_c('div',{staticClass:"legend-container"},[_c('chart-legend')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }